import { dotSpinner } from 'ldrs';

// Register the loader component
dotSpinner.register();

class LoadingIndicator extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="loading-backdrop"></div>
      <div class="loading-spinner">
        <l-dot-spinner
          size="40"
          speed="0.9"
          color="#948979"
        ></l-dot-spinner>
      </div>
    `;
  }

  show() {
    this.style.display = 'block';
  }

  hide() {
    this.style.display = 'none';
  }
}

customElements.define('loading-indicator', LoadingIndicator);

export default LoadingIndicator;
